// Načítání virtuální prohlídky a videoprohlídky
const inicializedVideoPlayers = {};
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".view-player").forEach(el => {
        el.addEventListener("click", () => loadPlayer(el))
    })
});

function loadPlayer(el) {
    const {type, id} = el.dataset;
    if (typeof inicializedVideoPlayers[type] !== 'undefined') {
        return;
    }
    inicializedVideoPlayers[type] = true;
    const playerTypes = {
        matterport: () => {
            const isMatterport = /matterport\.com/i.test(id);
            if (!isMatterport) {
                return createIframe(id);
            }

            const hasPlayParam = /([?&])play=1(&|$)/.test(id);
            if (hasPlayParam) {
                return createIframe(id);
            }

            const matterportId = id.endsWith('/') ? id : `${id}/`;
            return createIframe(`${matterportId}&play=1`);
        },
        youtube: () => createIframe(`https://www.youtube.com/embed/${id}?autoplay=1`),
        video: () => createVideo(id)
    };
    if (playerTypes[type]) {
        el.innerHTML = "";
        el.appendChild(playerTypes[type]())
    }
}

function createIframe(src) {
    const iframe = document.createElement("iframe");
    iframe.src = src;
    iframe.frameBorder = "0";
    iframe.allowFullscreen = true;
    iframe.allow = "autoplay; encrypted-media";
    return iframe;
}

function createVideo(src) {
    const video = document.createElement("video");
    video.src = src;
    video.controls = true;
    video.autoplay = true;
    return video;
}
